<template>
  <div>
    <p>Location</p>
    <!-- <locationDrop class="locationDropDisp" :startingId="'0'" :states="locationStates" :enabled="locationDropDownEnabled"
                  @selection="locationSelected"></locationDrop> -->

    <div class="container">
      <div class="custom-select">  
        <select :disabled="!locationDropDownEnabled" @change="locationSelected($event.target.value)" v-model="selectedLocation">
          <option  v-for="(item, index) in locationStates" :key="index" :value="item">{{ item }}</option>
        </select>
      </div>
    </div>
  </div>

  <div>
    <p>Vehicle</p>
    <!-- <vehicleDrop class="vehicleDropDisp" :startingId="'0'" :states="vehicleStates" :enabled="vehicleDropDownEnabled"
                 @selection="vehicleSelected"></vehicleDrop> -->

    <div class="container">
      <div class="custom-select">  
        <select :disabled="!vehicleDropDownEnabled" @change="vehicleSelected($event.target.value)" v-model="selectedMachine">
          <option v-for="(item, index) in vehicleStates" :key="index" :value="item">{{ item }}</option>
        </select>
      </div>
    </div>

  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();

import { ref, defineProps, defineEmits, toRefs, onMounted, inject } from 'vue';
import { gatedFetch } from '@/services/gatedFetch.js';
const reportsBase = inject('reportsBase');
import { useStore } from 'vuex';
const store = useStore();
// import LocationDrop from '../../components/dropdowns/dropdown1.vue';
// import VehicleDrop from '../../components/dropdowns/dropdown1.vue';

const props = defineProps({src: String});
const {src} = toRefs(props);
const emit = defineEmits(['selected']);

// console.log("VTYPE", src);

let currentDropletId = "";
let locationDropDownEnabled = ref(false);
let vehicleDropDownEnabled = ref(false);

let locationStates = ref({});
let vehicleStates = ref({});

let selectedLocation = ref("");
let selectedMachine = ref("");
let machine = ref(store.state.operationsLocation);
let locations = {
  "LCL1": {
    id: 110,
    loc: "NGO",
  },
  "LCL3": {
    id: 111,
    loc: "NGO",
  },
  "MTS1": {
    id: 100,
    loc: "NGO",
  },
  "MTS4": {
    id: 101,
    loc: "NGO",
  },
  "LCL2": {
    id: 210,
    loc: "TAR",
  },
  "LCL4": {
    id: 211,
    loc: "TAR",
  },
  "MTS2": {
    id: 200,
    loc: "TAR",
  },
  "MTS3": {
    id: 201,
    loc: "TAR",
  },
  "LCL5": {
    id: 310,
    loc: "IAB",
  },
  "LCL7": {
    id: 311,
    loc: "IAB",
  },
  "MTS5": {
    id: 300,
    loc: "IAB",
  },
  "MTS7": {
    id: 301,
    loc: "IAB",
  },
  "LCL6": {
    id: 410,
    loc: "PAE",
  },
  "LCL8": {
    id: 411,
    loc: "PAE",
  },
  "MTS6": {
    id: 400,
    loc: "PAE",
  },
  "MTS9": {
    id: 401,
    loc: "PAE",
  },
  "LCL9": {
    id: 500,
    loc: "CHS",
  },
  "LCL10": {
    id: 501,
    loc: "CHS",
  },
  "MTS8": {
    id: 510,
    loc: "CHS",
  },
  "MTS10": {
    id: 511,
    loc: "CHS",
  }
};

onMounted(() => {
  let i = store.state.operationsLocation;
  if (store.state.operationsLocation != '') {
    if (route.name == 'LclMonitoring' && i.toLowerCase().includes('lcl')) {
      openMachine();
    } else if (route.name === 'MtsMonitoring' && i.toLowerCase().includes('mts')) {
      openMachine();
    }
    // openMachine();
  }
});
function openMachine() {
  selectedMachine.value = machine.value;
  selectedLocation.value = locations[machine.value].loc;
  locationSelected(selectedLocation.value);
  vehicleSelected(machine.value);
};
const getLocationsUrl = reportsBase + "screens/projects/BDL/scripts/getTags.php?locSel";
let getVehicleUrl = reportsBase + "screens/projects/BDL/scripts/getTags.php?dropSel&type=" + src.value + "&location=";

gatedFetch(getLocationsUrl, {
  headers: {'Content-type': 'application/json'},
}).then((res) => res.json()).then((response) => {
  locationStates.value = response;
  locationDropDownEnabled.value = true;
}).catch((error) => {
  console.log("LOCATION FETCH ERROR " + error);
});

let currentlySelectedLocationId = "";

function locationSelected(id) {
  vehicleStates.value = {};
  currentlySelectedLocationId = id;
  gatedFetch(getVehicleUrl + id, {
    headers: {'Content-type': 'application/json'},
  }).then((res) => res.json()).then((response) => {
    vehicleStates.value = response;
    vehicleDropDownEnabled.value = true;
  }).catch((error) => {
    console.log("VEHICLE FETCH ERROR " + error);
  });
}

function vehicleSelected(i) {
  if (i.toLowerCase().includes('mts') || i.toLowerCase().includes('lcl')) {
    currentDropletId = locations[i].id;
    emit('selected', {
        "droplet": currentDropletId,
        "location": locationStates.value[currentlySelectedLocationId],
        "vehicle": i,
      }
    );
  } else {
    currentDropletId = i;
    emit('selected', {
        "droplet": currentDropletId,
        "location": locationStates.value[currentlySelectedLocationId],
        "vehicle": i,
      }
    );
  }
}
</script>

<style lang="scss" scoped>
.container {
  position:relative;
  contain: layout;
}
.custom-select {
  height: 40px;
  border-radius: 10px;
	position: relative;
  width: 100%;
  @media screen and (max-width: 480px), screen and (max-height: 480px) and (orientation: landscape){
    width: auto;
  }
  select{
    border: 1px solid red;
  }
  select {
    appearance: none;
    /*  safari  */
    -webkit-appearance: none;
    /*  other styles for aesthetics */
    text-indent: 12px;
    width: 100%;
    background-color: #fff;
    border: 1px solid #BCBCBC;
    border-radius: 10px;
    color: #252525;
    cursor: pointer;
    height: 36px;
    font-size: 1rem;
    font-weight: 400;
    outline: none;
  }
}
.custom-select::before{
  content: "";
  position: absolute;
  right: 1rem;
  pointer-events: none;
}

.custom-select::before {
	height: 24px;
	width: 24px;
	top: 50%;
	transform: translateY(-50%);
	right: 12px;
	background-image: url(../../../public/img/arr_down.svg);
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center left;
}
</style>